<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        prepend-icon="mdi-web"
        append-icon="mdi-chevron-down"
        class="mt-3"
        block
        size="small"
        variant="text"
        v-bind="props"
      >
        {{ currentLanguage.name }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="lang in languages"
        :key="lang.code"
        :active="currentLanguage.code === lang.code"
        @click="changeLanguage(lang.code)"
      >
        <v-list-item-title>{{ lang.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { useLanguage } from "@/composables/useLanguage";

const { languages, changeLanguage, currentLanguage } = useLanguage();
</script>
